module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-10.799751f4.png";